import React, { FC } from 'react'
import styled from 'styled-components'
import { Text } from '../../../redesign/text/textStyles'

interface Props {
    text: string
}

const Container = styled(Text)`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 4px 8px;
    background-color: #880a47;
    border-radius: 4px;
`

export const SubscriptionDiscount: FC<Props> = ({ text }) => {
    return (
        <Container size="xSmall" $weight="regular" color="white">
            {text}
        </Container>
    )
}
